enum PartAmountCheckState {
    NOT_STARTED = 'not_started',
    PENDING = 'pending',
    RUNNING = 'running',
    COMPLETED = 'completed',
    TIMEOUT = 'timeout',
}

export default PartAmountCheckState;
